module.exports = __webpack_public_path__ + "media/CN_011.1923f363.mp3";